import gql from 'graphql-tag';

export default gql`
    mutation DeleteB2CUser($input: DeleteB2CUserInput) {
        deleteB2CUser(input: $input) {
            errors
        }
    }
`;
